module.exports = __webpack_public_path__ + "img/danger.2298cc7e.svg";